import actions from './actions';
import reducers from './reducers';
import sagas from './sagas';

export default {
    actions,
    reducers,
    sagas,
}
